import {
    Box,
    Card,
    CardContent,
    Grid,
    IconButton,
    Modal,
    TextField,
    Tooltip,
    Typography,
    Snackbar,
    Alert, Chip
} from "@mui/material"
import {useEffect, useState} from "react"
import CloseIcon from '@mui/icons-material/Close';
import {Controller, useForm} from "react-hook-form";
import {msg} from "@lingui/macro";
import {useLingui} from "@lingui/react";
import httpReq from "../../../services/httpReq";
import {FolderZip} from "@mui/icons-material";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const ModalViewReport = ({row, setIsModalOpen, isModalOpen, isMobile}) => {
    const {control, reset} = useForm({
        mode: 'onChange',
        defaultValues: {
            title: "",
            description: "",
            reporter: "",
            latitude: "",
            longitude: "",
            beginLatitude: "",
            beginLongitude: "",
            endLatitude: "",
            endLongitude: ""
        }
    })
    const [reportAttachments,setReportAttachments] = useState([]);
    const [isLoadingAttachments,setIsLoadingAttachments] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    useEffect(() => {
        console.log('row --- ', row)
        reset({
            title: row.title,
            description: row.description,
            reporter: row.reporterCompleteName,
            latitude: row.latitude,
            longitude: row.longitude,
            beginLatitude: row.beginLatitude,
            beginLongitude: row.beginLongitude,
            endLatitude: row.endLatitude,
            endLongitude: row.endLongitude
        });
        getReportAttachments()
    }, [row, reset]);

    const {_} = useLingui()

    const readOnlyStyle = {
        backgroundColor: "#f5f5f5",
        WebkitTextFillColor: "black"
    };

    const getReportAttachments = async () => {

        const res = await httpReq('ReportAttachment/GetList/' + row.id, 'GET', null, true);
        if (!res || res.responseAnyError) return;
        if(res.responseData.length > 0) {
            setIsLoadingAttachments(true)
            const p = res.responseData.map(async att => {
                const singleAttReq = await httpReq('ReportAttachment/Get/' + att.id, 'GET', null, true);
                if (!singleAttReq || singleAttReq.responseAnyError) return;
                att.fileContent = singleAttReq.responseData.fileContent
                return att;
            })
            const responsePool = await Promise.all(p)
            setReportAttachments(responsePool);
        }
        setIsLoadingAttachments(false)
    }

    const downloadAttachmentsZip = async () => {
        setIsDownloading(true);

        const zip = new JSZip();
        reportAttachments.forEach((file) => {
            const byteCharacters = atob(file.fileContent);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            zip.file(file.fileName, byteArray, { binary: true });
        });

        const content = await zip.generateAsync({ type: "blob" });
        saveAs(content, `${row.title}-files.zip`);

        setIsDownloading(false);
    }

    return (
        <>
            <Modal sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}} open={isModalOpen}>
                <Card sx={{width: !isMobile ? '50vw' : '100vw', height: isMobile ? '100vh' : '80vh'}}>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5}}>
                        <Box sx={{flex: 1}}/>
                        <Typography variant="h6" align="center" sx={{flex: 1}}>
                            {`View ${row.title} report`}
                        </Typography>
                        <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 1}}>
                            {isLoadingAttachments ? (
                                <Typography variant="body2" sx={{ display: "flex", alignItems: "center", color: "gray" }}>
                                    {_(msg`Loading files...`)}
                                </Typography>
                            ) : (
                                <Tooltip title={_(msg`Download report files`)}>
                                    <IconButton disabled={reportAttachments.length === 0} onClick={() => downloadAttachmentsZip()}>
                                        <FolderZip/>
                                    </IconButton>
                                </Tooltip>
                            )}
                            <IconButton onClick={() => setIsModalOpen(false)}><CloseIcon color="error"/></IconButton>
                        </Box>
                    </Box>
                    <CardContent>
                        <Grid container spacing={1}>
                            {[
                                {name: 'title', label: _(msg`Title`), xs: 12},
                                {name: 'description', label: _(msg`Description`), xs: 12},
                                {name: 'reporter', label: _(msg`Reporter`), xs: 12},
                                {name: 'beginLatitude', label: _(msg`Latitude`), xs: 6},
                                {name: 'beginLongitude', label: _(msg`Longitude`), xs: 6},
                                ...(row.endLatitude && row.endLongitude
                                        ? [
                                            {name: 'endLatitude', label: _(msg`End Latitude`), xs: 6},
                                            {name: 'endLongitude', label: _(msg`End Longitude`), xs: 6}
                                        ]
                                        : []
                                )
                            ].map((fieldData) => (
                                <Grid item xs={fieldData.xs} key={fieldData.name}>
                                    <Controller
                                        name={fieldData.name}
                                        control={control}
                                        render={({field}) => (
                                            <TextField
                                                margin={isMobile ? 'dense' : 'normal'}
                                                fullWidth
                                                label={fieldData.label}
                                                InputProps={{
                                                    readOnly: true,
                                                    sx: readOnlyStyle
                                                }}
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item sx={{ mt: 4, display:'flex', flexWrap: 'wrap', gap: 1 }}>
                            {row.tagValues.map(tagValue => (
                                <Tooltip
                                    key={'tag-value-' + tagValue.id}
                                    title={tagValue.value}
                                    arrow
                                    componentsProps={{ tooltip: { sx: { fontSize: 13 } } }}
                                >
                                    <Chip
                                        label={`${tagValue.tagValue.tag.name} - ${tagValue.tagValue.value}`}
                                        variant="outlined"
                                        sx={{
                                            fontWeight: 'bold',
                                            backgroundColor: tagValue.tagValue.color,
                                            color: 'white'
                                        }}
                                    />
                                </Tooltip>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            </Modal>

            {/* Snackbar per il download */}
            <Snackbar
                open={isDownloading}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert severity="info" sx={{ width: '100%' }}>
                    Downloading zip...
                </Alert>
            </Snackbar>
        </>
    )
}

export default ModalViewReport;
